import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

const sendEvent = (name) => {
  try {
    api.post("/visits/event", { event: name }).catch(() => {});
  } catch {
    /* ignora */
  }
};

const CLICK_EVENTS = {
  "hero-cta-button": "cta_prenota_click",
  "floating-cta-button": "cta_float_click",
  "navbar-menu-link": "menu_click",
  "hero-menu-button": "menu_click",
  "coupon-call-button": "phone_click",
  "coupon-download-button": "ticket_save_click",
  "reservation-submit-button": "form_submit_attempt",
};

export const FunnelTracker = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname.startsWith("/admin")) return undefined;

    const section = document.getElementById("coupon-form");
    let observer;
    if (section && !sessionStorage.getItem("baianeira_form_view")) {
      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              sessionStorage.setItem("baianeira_form_view", "1");
              sendEvent("form_view");
              observer.disconnect();
            }
          });
        },
        { threshold: 0.3 }
      );
      observer.observe(section);
    }

    const onClick = (e) => {
      const el = e.target.closest("[data-testid]");
      if (!el) return;
      const testid = el.getAttribute("data-testid");
      const mapped = CLICK_EVENTS[testid];
      if (mapped) {
        sendEvent(mapped);
        return;
      }
      // traccia ogni altro tasto o link cliccato (solo il nome, nessun dato personale)
      const isControl = el.tagName === "BUTTON" || el.tagName === "A" || el.tagName === "INPUT";
      if (isControl && !testid.startsWith("admin-") && !testid.startsWith("stats-")) {
        sendEvent(("click_" + testid).replace(/[^a-z0-9_]/g, "_").slice(0, 40));
      }
    };

    const onFirstInput = (e) => {
      if (
        e.target.closest &&
        e.target.closest('[data-testid="reservation-form"]') &&
        !sessionStorage.getItem("baianeira_form_start")
      ) {
        sessionStorage.setItem("baianeira_form_start", "1");
        sendEvent("form_start");
      }
    };

    document.addEventListener("click", onClick);
    document.addEventListener("input", onFirstInput);
    document.addEventListener("change", onFirstInput);
    return () => {
      if (observer) observer.disconnect();
      document.removeEventListener("click", onClick);
      document.removeEventListener("input", onFirstInput);
      document.removeEventListener("change", onFirstInput);
    };
  }, [pathname]);

  return null;
};

export default FunnelTracker;
